import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import ModernNavbar from './components/ModernNavbar';
import ModernFooter from './components/ModernFooter';
import FloatingChatbot from './components/FloatingChatbot';
import ErrorBoundary from './components/ErrorBoundary';
import GlobalStyles from './styles/GlobalStyles';
import ThemeProvider from './context/ThemeContext';

// Lazy load pages for better code splitting
const HomePage = React.lazy(() => import('./pages/HomePage'));
const BlogPage = React.lazy(() => import('./pages/BlogPage'));
const Gallery = React.lazy(() => import('./pages/Gallery'));

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const PageLoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  padding: 60px 20px;
`;

const PageLoadingSpinner = styled.div`
  width: 50px;
  height: 50px;
  border: 4px solid ${props => props.theme.colors.border};
  border-top: 4px solid ${props => props.theme.colors.primary};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const PageFallback = () => (
  <PageLoadingContainer>
    <PageLoadingSpinner />
  </PageLoadingContainer>
);

const AppContainer = styled.div`
  min-height: 100vh;
  overflow-x: hidden;
`;

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <GlobalStyles />
        <Router>
          <AppContainer>
            <ErrorBoundary>
              <ModernNavbar />
            </ErrorBoundary>
            <ErrorBoundary>
              <Suspense fallback={<PageFallback />}>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/blog" element={<BlogPage />} />
                  <Route path="/gallery" element={<Gallery />} />
                </Routes>
              </Suspense>
            </ErrorBoundary>
            <ErrorBoundary>
              <ModernFooter />
            </ErrorBoundary>
            <ErrorBoundary>
              <FloatingChatbot />
            </ErrorBoundary>
          </AppContainer>
        </Router>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
